import React from "react";
import "./BusLoader.css";

const BusLoader = ({ message = "Preparing live map..." }) => {
  return (
    <div className="bus-loader-overlay">
      <div className="loader-map-glow" />
      <div className="loader-grid" />

      <div className="bus-loader-container">
        <div className="loader-brand">
          <span className="loader-brand__mark">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9">
              <path d="M8 6v6M16 6v6M2 12h19.6" />
              <path d="M18 18h3V9c0-1.7-1.3-3-3-3H6C4.3 6 3 7.3 3 9v9h3" />
              <circle cx="7" cy="18" r="1.7" />
              <circle cx="17" cy="18" r="1.7" />
            </svg>
          </span>
          <div>
            <h1>Rodhak</h1>
            <p>Live Map</p>
          </div>
        </div>

        <div className="loader-route">
          <span className="loader-pin loader-pin--start" />
          <svg viewBox="0 0 240 84" aria-hidden="true">
            <path className="loader-route__shadow" d="M12 62 C55 8, 93 82, 132 34 S202 16, 228 56" />
            <path className="loader-route__line" d="M12 62 C55 8, 93 82, 132 34 S202 16, 228 56" />
          </svg>
          <span className="loader-pin loader-pin--end" />
          <span className="loader-bus">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9">
              <path d="M8 6v6M16 6v6M2 12h19.6" />
              <path d="M18 18h3V9c0-1.7-1.3-3-3-3H6C4.3 6 3 7.3 3 9v9h3" />
              <circle cx="7" cy="18" r="1.7" />
              <circle cx="17" cy="18" r="1.7" />
            </svg>
          </span>
        </div>

        <div className="loader-content">
          <span className="loader-kicker">Syncing route intelligence</span>
          <h2>{message}</h2>
          <div className="loader-progress" aria-hidden="true">
            <span />
          </div>
          <div className="loader-status rd-mono">
            <span>Mapbox</span>
            <i />
            <span>Trips</span>
            <i />
            <span>Socket</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusLoader;
